// src/components/inventory/TruckExtraCard.js
//
// #682, Session 79.22b.6c.2b -- HOUSTON'S QUESTION, "DID 4 GO ON THE TRUCK?"
// The corrections gate's P6 (callouts L and M; 682 D7, D13, D16):
//   docs/gates/Stede_Corrections_Gate_682_702_761.html
//
// Dallas counted more than a truck's sheet. The database booked the sheet's
// number and asked the sending branch about the rest; the question sits on the
// sending branch's Awaiting confirmation tab, for the truck's loader and its
// branch leads only (canAnswerTruckExtra(), decided by the page). One press
// answers it: Yes corrects the truck and books the extra at Dallas; No tells
// Dallas the sheet was right. With no room on the order for the extra, the
// card says so and offers Settle alone (682 D16).
//
// BUILT EXACTLY AS DRAWN (682 D14): the attention pair, a 12px radius and the
// card shadow; the reference in the head face at 12px; the question at 14px,
// weight 600; two buttons side by side, 48px with a finger. After an answer
// the card stays in its place with what happened until the next press (gate
// 665's pinned card), in the done pair the gate's answers use. A refusal is
// answered under the buttons, never silently (#492).
//
// The words are corrections.js's pure functions; this file only draws them.

import React from 'react';
import ActionButton from '../ActionButton';
import { useTier, controlHeight } from '../../lib/tiers';

const CARD = {
  background: '#FFF8EC', color: '#8A5A08', border: '1px solid #D0D0D0', borderRadius: 12,
  boxShadow: '0 1px 3px rgba(0,0,0,.08)', padding: 12,
};
const REF = {
  margin: '0 0 6px', fontFamily: 'var(--font-head)', fontWeight: 700, fontSize: 12,
  letterSpacing: '.5px', textTransform: 'uppercase', color: '#8A5A08',
};
const ASK = { margin: 0, fontSize: 14, fontWeight: 600, lineHeight: 1.35 };
const BTN = {
  flex: 1, margin: 0, borderRadius: 8, padding: '0 12px', fontFamily: 'var(--font-head)', fontWeight: 700,
  fontSize: 14, letterSpacing: '.5px', textTransform: 'uppercase', lineHeight: 1,
  display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer',
};
const PRI = { ...BTN, background: '#39D353', color: '#0F0F0F', border: '1px solid #39D353' };
const SEC = { ...BTN, background: '#fff', color: '#0F0F0F', border: '1px solid #D0D0D0' };

// entry: { key, head, text, room, yesLabel, noLabel, settleLabel,
//          pinned: { text, tone } | null, refusal: string | null,
//          pressing: the answer being saved, so only its button says Saving… }
export default function TruckExtraCard({ entry, busy = false, onAnswer }) {
  const { coarse } = useTier();
  if (!entry) return null;
  const h = controlHeight(coarse, 'commit');
  const pinned = entry.pinned || null;
  return (
    <article aria-label={entry.head} style={CARD} data-truck-extra={entry.key}>
      <p style={REF}>{entry.head}</p>
      <p style={ASK}>{entry.text}</p>
      {pinned ? (
        <p role="status" style={pinned.tone === 'done' ? {
          margin: '12px 0 0', background: '#E1F5EE', color: '#085041', borderRadius: 8,
          padding: '8px 12px', fontSize: 13, lineHeight: 1.35, fontWeight: 600,
        } : { margin: '12px 0 0', fontSize: 13, lineHeight: 1.35, fontWeight: 600 }}>
          {pinned.text}
        </p>
      ) : (
        <div style={{ display: 'flex', gap: 8, alignItems: 'stretch', marginTop: 12 }}>
          {entry.room ? (
            <>
              <ActionButton style={{ ...PRI, height: h }} busy={busy} busyLabel={entry.pressing === 'went' ? 'Saving…' : undefined}
                onClick={() => onAnswer?.('went')}>
                {entry.yesLabel}
              </ActionButton>
              <ActionButton style={{ ...SEC, height: h }} busy={busy} busyLabel={entry.pressing === 'did_not_go' ? 'Saving…' : undefined}
                onClick={() => onAnswer?.('did_not_go')}>
                {entry.noLabel}
              </ActionButton>
            </>
          ) : (
            <ActionButton style={{ ...PRI, height: h }} busy={busy} busyLabel={entry.pressing === 'settle' ? 'Saving…' : undefined}
              onClick={() => onAnswer?.('settle')}>
              {entry.settleLabel}
            </ActionButton>
          )}
        </div>
      )}
      {entry.refusal && !pinned && (
        <p role="alert" style={{ margin: '8px 0 0', fontSize: 13, lineHeight: 1.35, fontWeight: 600, color: '#A32D2D' }}>
          {entry.refusal}
        </p>
      )}
    </article>
  );
}
